export default __webpack_public_path__ + "static/media/stereo_10.2696a367.gif";